import { DateTime } from "@common/data-models/complex-types/date-time";

export class UserLocation {

    private _lat: number;
    private _lon: number;
    private _deviceId: string;
    private _date: DateTime;

    constructor(lat: number, lon: number, deviceid: string, date: DateTime) {
        this._lat = lat;
        this._lon = lon;
        this._deviceId = deviceid;
        this._date = date;
    }

    public get latitude(): number {
        return this._lat;
    }

    public set latitude(lat: number) {
        this._lat = lat;
    }

    public get longitude(): number {
        return this._lon;
    }

    public set longitude(lon: number) {
        this._lon = lon;
    }

    public get deviceid(): string {
        return this._deviceId;
    }

    public set deviceid(deviceid: string) {
        this._deviceId = deviceid;
    }

    public get date(): DateTime {
        return this._date;
    }

    public set date(date: DateTime) {
        this._date = date;
    }
}
